var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconDownload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico-download1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "dimension",
    width: 24,
    height: 24,
    fill: "#0071b9",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icongraphic",
    d: "M19.107,23.3l-4.236-4.468,1.342-1.378,2.3,2.511s0-10.529,0-10.529a.912.912,0,1,1,1.824,0V19.963l2.3-2.5L23.99,18.84,19.762,23.3A.448.448,0,0,1,19.107,23.3Zm6.938-.052v1.872H12.824V23.247H11v2.808a.924.924,0,0,0,.912.936H26.957a.924.924,0,0,0,.912-.936V23.247Z",
    transform: "translate(-7.452 -5.758)",
    fill: "#0071b9"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.c638b4c6.svg";
export { ForwardRef as ReactComponent };